import { Injectable } from '@angular/core';
import type { Stripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../config/api.config';

/** Thin singleton around Stripe.js's `loadStripe` — the Payment Element is
 * mounted per-checkout by ProductDetailComponent / the secure-trade pay
 * flow. `@stripe/stripe-js` (the default entry) injects js.stripe.com as
 * soon as the module is evaluated, which PageSpeed flagged as unused JS on
 * every page that pulled this service into a bundle. `/pure` only injects
 * when `loadStripe()` runs, and the dynamic import keeps even that wrapper
 * off the page until the buyer reaches the payment step. */
@Injectable({ providedIn: 'root' })
export class StripeClientService {
  private stripePromise: Promise<Stripe | null> | null = null;

  getStripe(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      this.stripePromise = import('@stripe/stripe-js/pure').then(({ loadStripe }) =>
        loadStripe(STRIPE_PUBLISHABLE_KEY),
      );
    }
    return this.stripePromise;
  }
}
